import React from "react";
import { CheckboxProps } from "../interfaces";

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { checked, className, disabled, label, onChange } = props;

  return (
    <button
      className="relative my-auto w-fit cursor-pointer pl-7 text-left outline-none disabled:cursor-default disabled:opacity-50"
      disabled={disabled}
      onClick={onChange}
      style={{
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
      }}
    >
      <input
        type="checkbox"
        className="peer absolute hidden cursor-pointer opacity-0 "
        checked={Boolean(checked)}
        onChange={onChange}
        disabled={disabled}
      />
      <span
        className={`block text-sm font-normal text-gray-900 ${className || ""}`}
      >
        {label}
      </span>
      <span className="absolute left-0 top-0 h-5 w-5 rounded-md border border-gray-400 bg-white after:absolute after:left-[6px] after:top-[2px] after:hidden after:h-[11px] after:w-[6px] after:rotate-45 after:transform after:border-b-[2px] after:border-l-0 after:border-r-[2px] after:border-t-0 after:border-white peer-checked:bg-black peer-checked:after:block" />
    </button>
  );
};
